import React, {useState, useEffect} from 'react'
import localization from "../../../../assets/localization/localization";
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import Layout from 'components/sales/layout/layout';
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import FormSection from "../../../../components/sales/formSection/formSectionNew";
import {toast} from "react-toastify";
import MemberDetails from "./MemberDetails";
import {Button} from "react-bootstrap";
import Images from "../../../../assets/images/imageData";
import './normal.css'

const NormalOnboarding = (
    {
        documentUploadUrlPublic,
        documentUrlDataPublic,
        getLeadInfraId,
        saveNormalCarnival,
        prefilledData,
        updateNormalOnboardingData,
        history
    }) => {


    const [inputList, setInputList] = useState([{
        project_name: "",
        society_name: "",
        fitkit:0,
        fitkit_price: "",
        rfid:0,
        rfid_price: "",
        rwa_members: 0
    }])
    const [projectId, setProjectId] = useState("");
    const [validateMessage, setProjectIdValidationMessage] = useState("")
    const [addMembers, setAddMembers] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [rwaMember, setRwaMember] = useState();
    const [inputMemberList, setInputMemberList] = useState([{first_name: "", last_name:"", image_url: "", designation: ""}]);
    const [isFitkitset, setFitkit] = useState(false)
    const [isRfidset, setRfid] = useState(false)
    const [projectName, setProjectName] = useState()
    const [isEdit , setIsEdit] = useState(false)

    useEffect(() => {
        const list = [...inputList];
        list[0]['rwa_members'] = 1;
        setInputList([...list]);
        setAddMembers(1);
    }, [])

    const handleProjectId = (projectId) => {
        setProjectId(projectId);
    }
    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
        console.log(inputList)
    };

    const handleInputChange = (e, index, type) => {
        const {name, value} = e.target;
        const list = [...inputMemberList];
        list[index][type] = value;
        setInputMemberList(list);
    };

    const handleCheckProject = async () => {
        setProjectIdValidationMessage("")
        if (projectId !== "") {
            let res = await getLeadInfraId(projectId)
            if(res.project_name !== "" && res.project_name !== undefined)
                setProjectName(res.project_name);
        } else {
            setProjectIdValidationMessage("Project is required")
        }
    }

    const handleMemberChange = (val) => {
        const list = [...inputList];
        list[0]['rwa_members'] = val;
        setInputList([...list]);
        setAddMembers(val);
        console.log(val);
        // setInputList({...inputList, rwa_members: val.id})
    };

    const handleRemoveClick = index => {
        const list = [...inputMemberList];
        list.splice(index, 1);
        setInputMemberList(list);
    };

    const handleAddClick = () => {
        var size = Object.keys(inputMemberList).length;
        if (size >= 3) {
            toast.error('members limit cannot exceed 3.');
        } else {
            setInputMemberList([...inputMemberList, {first_name: "", last_name:"", image_url: "", designation: ""}]);
        }
    };

    const saveImage = (val, index = null) => {
        if (index != null) {
            const list = [...inputMemberList];
            list[index]["image_url"] = val;
            setInputMemberList(list);
        }
    };

    const handleChangeFitKit = (val) => {

        handleInputValue('', 'fitkit');
        handleInputValue('', 'fitkit_price');
        if(val.id === 1){
            setFitkit(true)
            handleInputValue(1, 'fitkit');
        }else{
            setFitkit(false)
            handleInputValue(0, 'fitkit');
        }
    }

    const handleChangeForRFID = (val) => {
        handleInputValue('', 'rfid_price');
        handleInputValue('', 'fitkit_price');
        if(val.id === 1){
            setRfid(true);
            handleInputValue(1, 'rfid');
       }
       else{
            setRfid(false);
            handleInputValue(0, 'rfid');
       } 
    }

    useEffect(() => {
        if (prefilledData?.normal_onboarding !== null && prefilledData?.normal_onboarding !== undefined) {
            const {
                id,
                project_id,
                project_name,
                society_name,
                fitkit_price,
                rfid_price,
                fitkit,
                rfid,
                members,
                rwa_members,
                services,
                member_exists
            } = prefilledData?.normal_onboarding;

            const list = [...inputList]
            setProjectId(project_id);
            setProjectName(project_name);
            list[0]['id'] = id
            list[0]['project_name'] = project_name
            list[0]['society_name'] = society_name
            list[0]['fitkit'] = fitkit
            list[0]['fitkit_price'] = fitkit_price
            list[0]['rfid'] = rfid
            list[0]['rfid_price'] = rfid_price
            list[0]['members'] = (members !== "") ? members : null
            list[0]['project_id'] = id
            setInputMemberList((members.length) ? members : [{ first_name:"", last_name:"",image_url: "", position: ""}]);
            setAddMembers((members.length) ? 1 : 2)
            // handleMemberChange(2);
            console.log(members);
            setFitkit((fitkit === 1))
            setRfid((rfid === 1))
            setIsEdit(true)
        }
    }, [prefilledData])

    const handleSubmit = () => {

        if(projectName !== "" && projectName !== undefined && projectId !== ''){
            inputList[0]['project_name'] = projectName
            inputList[0]['project_id'] = projectId

            inputList[0]['members'] = [];
            if(inputMemberList && inputMemberList[0] && inputMemberList[0]['first_name'] !== ""){
                inputList[0]['members'] = inputMemberList;
            }
            
            (async () => {
                if(isEdit){
                    setIsLoading(true)
                    const res = await updateNormalOnboardingData(inputList[0])
                    setIsLoading(false)
                    if (res) {
                        toast.success('Data is updated');

                    }
                } else {
                    setIsLoading(true)
                    const res = await saveNormalCarnival(inputList[0]);
                    setIsLoading(false)
                    if (res) {
                        toast.success('Data is successfully added');
                        window.location.reload(false);
                    }
                }
              })();
        }
    }

    const headerBtns = () => {
        return (
            <Button onClick={handleSubmit} className="btn btn-primary">
                {localization.submit}
                <img src={Images?.ArrowRight} alt="" />
            </Button>
        );
    };
    return (
        <>
            <Layout isGoback isLoading={isLoading} Buttons={headerBtns}>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 col-sm-12">
                                    <div className="w3-text-red w3-align-left">{validateMessage}</div>
                                    <ConstantInput
                                        label={localization.projectId}
                                        value={projectId}
                                        type="text"
                                        handleChange={(value) => handleProjectId(value)}
                                        disabled={isEdit}
                                    />
                                </div>
                                <div className="col-md-2 col-sm-5">
                                    <button className="btn btn-sm btn-primary" onClick={handleCheckProject}>Check
                                    </button>
                                </div>
                                {projectName !== undefined &&
                                <>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label={localization.projectName}
                                            type="text"
                                            value={projectName}
                                            handleChange={(val) => {
                                                handleInputValue(val, 'project_name');
                                            }}
                                            required
                                            isStarRequired={true}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="col-md-6 col-sm-12">
                                        <ConstantInput
                                            label={localization.societyName}
                                            type="text"
                                            value={inputList[0].society_name}
                                            handleChange={(val) => {
                                                handleInputValue(val, 'society_name');
                                            }}
                                            maxLength={20}
                                            required
                                            isStarRequired={true}
                                        />
                                    </div>
                                    <FormSection title={localization.FITKITRFIDDetails}>
                                        <div className="row form-group">
                                            <div className="col-md-3 col-sm-12">
                                                <DropDownInput
                                                    data={[
                                                        {name: 'Yes', id: 1},
                                                        {name: 'No', id: 2}
                                                    ]}
                                                    label={localization.fitkit}
                                                    required={true}
                                                    isStarRequired={true}
                                                    errorMsg={localization.isRequired}
                                                    getIdValue={(val) => handleChangeFitKit(val)}
                                                    value={inputList[0].fitkit === 1 ? 'Yes' : ''}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-12 fitkit-rfid-space">
                                                <DropDownInput
                                                    data={[
                                                        {name: 'Yes', id: 1},
                                                        {name: 'No', id: 2}
                                                    ]}
                                                    label={localization.rfid}
                                                    required={true}
                                                    isStarRequired={true}
                                                    errorMsg={localization.isRequired}
                                                    getIdValue={(val) => handleChangeForRFID(val)}
                                                    value={inputList[0].rfid === 1 ? 'Yes' : ''}
                                                />
                                            </div>
                                            {isFitkitset && isRfidset && <ConstantInput
                                                label={localization.fitkitPrice}
                                                className={"fitkit-rfid-space"}
                                                type="number"
                                                value={inputList[0].fitkit_price}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'fitkit_price', 0);
                                                }}
                                                required
                                                isStarRequired={true}
                                            />}
                                            
                                            {isRfidset && <ConstantInput
                                                label={localization.rfidPrice}
                                                type="number"
                                                value={inputList[0].rfid_price}
                                                handleChange={(val) => {
                                                    handleInputValue(val, 'rfid_price', 0);
                                                }}
                                                required
                                                className={"rfid-space"}
                                                isStarRequired={true}
                                            />}
                                        </div>
                                    </FormSection>
                                    <FormSection title={localization.memberDetails}>
                                        <div className="row form-group">
                                            <div className="col-md-3 col-sm-12">
                                                <DropDownInput
                                                    data={[
                                                        {name: 'Yes', id: 1},
                                                        { name: 'No', id: 2 }
                                                    ]}
                                                    label={localization.addMembers}
                                                    required={true}
                                                    isStarRequired={true}
                                                    errorMsg={localization.isRequired}
                                                    getIdValue={(val) => handleMemberChange(val.id)}
                                                    value={addMembers===1?'Yes':'No'}
                                                    // disabled={true}
                                                />
                                            </div>
                                        </div>
                                        {/*{addMembers}*/}
                                        <MemberDetails
                                            addMembers={addMembers}
                                            handleInputChange={handleInputChange}
                                            inputMemberList={inputMemberList}
                                            documentUploadUrl={documentUploadUrlPublic}
                                            documentUrlData={documentUrlDataPublic}
                                            saveImage={saveImage}
                                            handleRemoveClick={handleRemoveClick}
                                            handleAddClick={handleAddClick}
                                            isEdit={isEdit}
                                        />
                                    </FormSection>
                                </>}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default NormalOnboarding